/**
 * Badge — count pill for navigation entries (unread messages, notifications).
 *
 * The number alone is meaningless to a screen reader sitting next to a nav
 * label, so the digits are hidden and `description` carries the meaning into
 * the link's accessible name ("Messages, 3 unread conversations").
 */
import './badge.css';

interface BadgeProps {
  /** Already formatted, including any `20+` / `99+` capping. */
  label: string;
  /** Full sentence for assistive tech, e.g. "3 unread conversations". */
  description: string;
  className?: string;
}

export function Badge({ label, description, className }: BadgeProps) {
  return (
    <>
      <span className={`ui-badge${className ? ` ${className}` : ''}`} aria-hidden>
        {label}
      </span>
      <span className="sr-only">{description}</span>
    </>
  );
}
